export default class ExternalHotelInfo {
  static fromJSON (json) {
    return new ExternalHotelInfo({
      url: json.url,
      dateFormat: json.dateFormat
    })
  }

  constructor ({ url, dateFormat }) {
    this.url = url
    this.dateFormat = dateFormat
  }
}
